import { Component, EventEmitter, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzSliderModule } from 'ng-zorro-antd/slider';

@Component({
  selector: 'app-symptom-assessment-day-picker',
  imports: [NzSliderModule, ReactiveFormsModule, FormsModule, TranslateModule],
  templateUrl: './symptom-assessment-day-picker.component.html',
  styleUrl: './symptom-assessment-day-picker.component.scss',
})
export class SymptomAssessmentDayPickerComponent {
  value = 3;
  marks = {
    1: '',
    2: '',
    3: '',
    4: '',
    5: '',
  };
  markLabels = ['1', '2', '3', '4', '5 o più'];
  @Output() daysEmitter: EventEmitter<number> = new EventEmitter<number>();

  onSliderChange(changes: any): void {
    this.daysEmitter.emit(changes);
  }
}
